<template>
    <div id="statement"
        :style="{
            'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
        }">
        <report-statement-header
        :title="title[index]">
        </report-statement-header>

        <report-statement-content
        :content="content[index]" index="0"
        ></report-statement-content>

        <report-statement-acceptance
        v-on:changeIndex="sumIndex()"
        :index="index"
        nextRouter="/report/generate">
        </report-statement-acceptance>
    </div>
</template>

<script>
import Header from '../../components/shared/report/statement/Header'
import Content from '../../components/shared/report/statement/Content'
import Acceptance from '../../components/shared/report/statement/Acceptance'

export default{
    name: "StatementOfUse",

    data: ()=>({
        title: '',
        content : '',
        index: 0,
        hasReloaded: '',
        reload: true
    }),

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        this.content = this.$store.getters.getReportsAgreementContent
        this.title = this.$store.getters.getReportsAgreementTitle
        this.hasReloaded = localStorage.getItem('reload');
        if (!this.hasReloaded) {
            localStorage.setItem('reload', this.reload);
            location.reload(true);
        }
    },

    components: {
        "report-statement-header": Header,
        "report-statement-content": Content,
        "report-statement-acceptance": Acceptance
    },

    methods : {
        sumIndex(){
            this.index = this.index + 1
        },
        reloadPage() {
            this.$router.go(0);
        }
    }
}
</script>


<style lang="scss">
    #statement{
        height: 100%;
        background-size: cover !important;
    }
</style>